import { render, staticRenderFns } from "./SidebarMenu.vue?vue&type=template&id=417f1556&scoped=true"
import script from "./SidebarMenu.vue?vue&type=script&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&lang=js"
import style0 from "./SidebarMenu.vue?vue&type=style&index=0&id=417f1556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "417f1556",
  null
  
)

export default component.exports